import { Icon, Row } from 'components';
import { theme } from 'lib';
import styled from 'styled-components';

const StyledTh = styled.th`
  padding: 12px 8px;
  border-bottom: 1px solid #000;
  ${(props) =>
    props.sortingEnabled &&
    `
    cursor: pointer;
    background-color: ${theme.GREY_10};

    &:hover {
      background-color: ${theme.GREY_10};
    }
  `}
  ${(props) => props.first && 'padding-left: 24px;'}
  ${(props) => props.last && 'padding-right: 24px;'}
  ${(props) => props.noBorder && 'border-bottom: 0;'}
  ${(props) => props.width100 && 'width: 100%;'}
`;

const CustomTh = (props) => {
  const { children, onSort, sortBy, sortingKey, first, last, noBorder, width100, center } = props;

  const pair = Object.entries(sortBy || {})[0];
  const sortingEnabled = !!sortBy && !!sortingKey;
  const isCurrentSort = pair && sortingKey === pair[0];
  const direction = pair && pair[0] === 1 ? 'up' : 'down';

  function handleOnSort() {
    if (!sortingEnabled) return;
    const newDirection = direction === 'up' ? -1 : 1;
    onSort({ [sortingKey]: pair[1] === 1 ? -1 : 1 });
  }

  return (
    <StyledTh
      sortingEnabled={sortingEnabled}
      onClick={handleOnSort}
      first={first}
      last={last}
      noBorder={noBorder}
      width100={width100}
    >
      {/* `center` pairs with Td's own `center` so a centered column's heading sits over its
          content. Default stays `between`, which is what every other admin table expects. */}
      <Row center between={!center} centerAll={center}>
        {children}

        {isCurrentSort && (
          <Icon type={pair[1] === 1 ? 'down' : 'up'} dimensions={10} marg="0 10px 0 0" />
        )}
      </Row>
    </StyledTh>
  );
};

export default CustomTh;
